export const SECTIONS = {
    PATIENT: 'patient',
    ANAMNESIS: 'anamnesis',
    DEMAND_DESCRIPTION: 'demand_description',
    PROCEDURES: 'procedures',
    BEHAVIOR_OBSERVATIONS: 'behavior_observations',
    CLINICAL_HISTORY: 'clinical_history',
    TESTS: 'tests',
    DIAGNOSIS: 'diagnosis',
    RECOMMENDATIONS: 'recommendations',
} as const;
